import api from "./api";

/** 撤销取消订阅-只限订阅周期到期之前 */
export const payCancelSubscriptionRoll = async (subscriptionId: string): Promise<string> => {
  const res = await api.post('/pay/cancel/subscription/roll', {
    subscription_id: subscriptionId
  });
  return res.data;
}